<template>
  <div class="main-layout">
    <div class="sidebar">
      <div class="user-info" @click="$router.push('/home/profile')">
        <el-avatar :size="40" :src="userInfo.avatar"></el-avatar>
        <span class="username">{{ userInfo.displayName }}</span>
      </div>
      <el-menu
        :default-active="activeMenu"
        class="menu"
        background-color="#304156"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
        router>
        <el-menu-item index="/home/welcome">
          <i class="el-icon-s-home"></i>
          <span>首页</span>
        </el-menu-item>
        <el-menu-item index="/home/banner">
          <i class="el-icon-picture-outline"></i>
          <span>轮播图管理</span>
        </el-menu-item>
        <el-menu-item index="/home/category">
          <i class="el-icon-menu"></i>
          <span>分类管理</span>
        </el-menu-item>
        <el-menu-item index="/home/user">
          <i class="el-icon-user"></i>
          <span>用户管理</span>
        </el-menu-item>
        <el-menu-item index="/home/product">
          <i class="el-icon-goods"></i>
          <span>商品管理</span>
        </el-menu-item>
        <el-menu-item index="/home/diy-material">
          <i class="el-icon-bangzhu"></i>
          <span>DIY材料管理</span>
        </el-menu-item>
        <el-menu-item index="/home/diy-studio">
          <i class="el-icon-headset"></i>
          <span>设计台素材</span>
        </el-menu-item>
        <el-menu-item index="/home/design-plaza">
          <i class="el-icon-magic-stick"></i>
          <span>设计广场管理</span>
        </el-menu-item>
        <el-menu-item index="/home/designer">
          <i class="el-icon-medal"></i>
          <span>设计师管理</span>
        </el-menu-item>
        <el-menu-item index="/home/poster">
          <i class="el-icon-picture-outline"></i>
          <span>首页流程图片</span>
        </el-menu-item>
        <el-menu-item index="/home/notice">
          <i class="el-icon-bell"></i>
          <span>首页通知弹窗</span>
        </el-menu-item>
        <el-menu-item index="/home/music">
          <i class="el-icon-headset"></i>
          <span>首页背景音乐</span>
        </el-menu-item>
        <el-menu-item index="/home/order">
          <i class="el-icon-s-order"></i>
          <span>订单管理</span>
        </el-menu-item>
        <el-menu-item index="/home/order-addon">
          <i class="el-icon-present"></i>
          <span>包装配送贺卡</span>
        </el-menu-item>
        <el-menu-item index="/home/customer-service">
          <i class="el-icon-service"></i>
          <span>客服二维码</span>
        </el-menu-item>
        <el-menu-item index="/home/profile">
          <i class="el-icon-s-custom"></i>
          <span>个人中心</span>
        </el-menu-item>
        <el-menu-item @click="handleLogout">
          <i class="el-icon-switch-button"></i>
          <span>退出登录</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="main-content">
      <router-view></router-view>
      <div class="footer">
        <a href="https://beian.miit.gov.cn/" target="_blank" class="beian-link">
          蒙ICP备2026004530号-1
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { getAdminProfile } from '@/api/admin'
import { getImageUrl } from '@/utils/ossImage'

const DEFAULT_AVATAR = 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'

export default {
  name: 'MainLayout',
  data () {
    return {
      userInfo: {
        displayName: localStorage.getItem('username') || '管理员',
        avatar: DEFAULT_AVATAR
      },
      activeMenu: '/home/welcome'
    }
  },
  created () {
    this.activeMenu = this.$route.path
    this.loadProfile()
    this.$root.$on('admin-profile-updated', this.applyProfile)
  },
  beforeDestroy () {
    this.$root.$off('admin-profile-updated', this.applyProfile)
  },
  methods: {
    async loadProfile () {
      try {
        const res = await getAdminProfile()
        this.applyProfile(res.data || {})
      } catch (error) {
        console.error('获取管理员资料失败:', error)
      }
    },
    applyProfile (profile) {
      const username = profile.username || localStorage.getItem('username') || '管理员'
      this.userInfo.displayName = username
      this.userInfo.avatar = getImageUrl(profile.avatar) || DEFAULT_AVATAR
      localStorage.setItem('username', username)
    },
    handleLogout () {
      localStorage.removeItem('token')
      localStorage.removeItem('username')
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.main-layout {
  display: flex;
  height: 100vh;
}

.sidebar {
  width: 200px;
  flex-shrink: 0;
  background-color: #304156;
  color: #fff;
}

.user-info {
  padding: 20px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #1f2d3d;
  cursor: pointer;
}

.username {
  margin-left: 10px;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.menu {
  border-right: none;
}

.main-content {
  flex: 1;
  min-width: 0;
  padding: 20px;
  box-sizing: border-box;
  background-color: #f0f2f5;
  overflow: auto;
  display: flex;
  flex-direction: column;
}

.footer {
  margin-top: auto;
  padding: 20px;
  text-align: center;
  color: #909399;
  font-size: 12px;
  background-color: #f0f2f5;
}

.beian-link {
  color: #909399;
  text-decoration: none;
}

.beian-link:hover {
  color: #409EFF;
  text-decoration: underline;
}
</style>
